"use strict";

// The Korean cosmetics landing content is rendered on the server. Refresh it
// alongside the products when filters reset a later page to the first page.
function updateYokoCollectionLanding(html) {
    document.querySelectorAll('[data-yoko-collection-fragment]').forEach((fragment) => {
        const source = html.getElementById(fragment.id);
        if (source) fragment.replaceWith(source.cloneNode(true));
    });

    const landing = document.querySelector('[data-yoko-category-landing]');
    if (!landing) return;
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && landing.dataset.canonicalUrl) canonical.href = landing.dataset.canonicalUrl;
    if (landing.dataset.pageTitle) document.title = landing.dataset.pageTitle;
}

// Restore server-rendered products, filters and sorting on collection/search Back/Forward.
window.addEventListener('popstate', () => {
    if (document.querySelector('#collection-products, [data-yoko-category-landing]')) window.location.reload();
});

// Use the actual URL query, not an HTML-escaped copy returned in section links.
function yokoSearchLink(href) {
    const url = new URL(href, window.location.origin + window.location.pathname + window.location.search);
    const query = new URLSearchParams(window.location.search);
    if (query.has('q') && url.origin === window.location.origin && url.pathname === window.location.pathname) {
        url.searchParams.set('q', query.get('q'));
    }
    return url.pathname + url.search + url.hash;
}

// Filtering and pagination share one request owner: stale responses never touch the page.
let yokoListingRequest = null;
function yokoListingError(retry) {
    const products = document.getElementById('collection-products');
    if (!products) return;
    const error = document.createElement('div');
    error.id = 'yoko-listing-error';
    error.className = 'ermsg mb15';
    error.setAttribute('role', 'alert');
    const message = document.createElement('p');
    message.textContent = window.yokoCollectionStrings.error;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn-sm';
    button.textContent = window.yokoCollectionStrings.retry;
    button.addEventListener('click', () => { button.disabled = true; retry(); }, { once: true });
    error.append(message, button);
    products.before(error);
}
function yokoListingFetch(url, apply, retry, rollback = () => {}) {
    yokoListingRequest?.abort();
    const controller = new AbortController();
    yokoListingRequest = controller;
    document.getElementById('yoko-listing-error')?.remove();
    document.body.classList.add('load-filters');
    const timeout = setTimeout(() => controller.abort(), 15000);
    return fetch(url, { signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error('Listing request failed');
        return response.text();
      }).then(text => {
        if (yokoListingRequest !== controller) return;
        const html = new DOMParser().parseFromString(text, 'text/html');
        if (!html.querySelector('#collection-products') && !html.querySelector('.noresult')) throw new Error('Missing listing');
        apply(html);
        try {
            pagination();
            if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
            initializeVideos();initBgimages();initializeScrollAnimationTrigger();
        } catch (error) { console.error(error); }
      }).catch(() => {
        if (yokoListingRequest !== controller) return;
        rollback();
        yokoListingError(retry);
      }).finally(() => {
        clearTimeout(timeout);
        if (yokoListingRequest !== controller) return;
        yokoListingRequest = null;
        document.body.classList.remove('load-filters');
        document.querySelectorAll('.load-more').forEach(button => button.classList.remove('loading'));
      });
}
function pagination(){
    document.querySelectorAll('.load-more').forEach(btn => {
        if (btn.dataset.yokoPaginationBound) return;
        btn.dataset.yokoPaginationBound = 'true';
        const url = yokoSearchLink(btn.getAttribute('href'));
        btn.setAttribute('href', url);
        if (btn.classList.contains('infinite')) {
            const observer = new IntersectionObserver(entries => {
                if (!entries.some(entry => entry.intersectionRatio === 1) || yokoListingRequest) return;
                observer.disconnect();
                loadMoreproducts(url);
            }, { threshold: 1.0 });
            observer.observe(btn);
        } else {
            btn.addEventListener('click', event => {
                event.preventDefault();
                if (yokoListingRequest) return;
                btn.classList.add('loading');
                loadMoreproducts(url);
            });
        }
    });
}
pagination();
function loadMoreproducts(url){
    if (yokoListingRequest) return;
    return yokoListingFetch(url, html => {
        const products = document.getElementById('collection-products');
        const pager = document.getElementById('pagination');
        const source = html.querySelector('#pagination');
        const more = html.querySelector('#collection-products');
        if (!more) throw new Error('Missing next page');
        products.insertAdjacentHTML('beforeend', more.innerHTML);
        if (pager) pager.innerHTML = source ? source.innerHTML : '';
    }, () => loadMoreproducts(url));
}

// Mobile filters share Shopify's form and AJAX results with the desktop sidebar.
// Keep navigation keyed by stable Shopify parameters, never translated labels/counts.
// Generated from locales/*: checked by mobile-filters.test.cjs. These strings
// let updated assets enhance an older server-rendered filter block immediately.
const yokoFilterTranslations = {
  "en": {
    "title": "Filters",
    "back": "Back",
    "close": "Close",
    "reset": "Reset",
    "searchBrand": "Search brands",
    "searchIngredient": "Search ingredients",
    "empty": "No matches",
    "show": "Show products",
    "loading": "Updating…"
  },
  "lv": {
    "title": "Filtri",
    "back": "Atpakaļ",
    "close": "Aizvērt",
    "reset": "Atiestatīt",
    "searchBrand": "Meklēt zīmolu",
    "searchIngredient": "Meklēt sastāvdaļu",
    "empty": "Nekas nav atrasts",
    "show": "Rādīt preces",
    "loading": "Atjaunina…"
  },
  "ru": {
    "title": "Фильтры",
    "back": "Назад",
    "close": "Закрыть",
    "reset": "Сбросить",
    "searchBrand": "Найти бренд",
    "searchIngredient": "Найти ингредиент",
    "empty": "Ничего не найдено",
    "show": "Показать товары",
    "loading": "Обновляем…"
  },
  "lt": {
    "title": "Filtrai",
    "back": "Atgal",
    "close": "Uždaryti",
    "reset": "Išvalyti",
    "searchBrand": "Ieškoti prekės ženklo",
    "searchIngredient": "Ieškoti ingrediento",
    "empty": "Nieko nerasta",
    "show": "Rodyti prekes",
    "loading": "Atnaujinama…"
  },
  "et": {
    "title": "Filtrid",
    "back": "Tagasi",
    "close": "Sulge",
    "reset": "Lähtesta",
    "searchBrand": "Otsi kaubamärki",
    "searchIngredient": "Otsi koostisosa",
    "empty": "Vasteid ei leitud",
    "show": "Näita tooteid",
    "loading": "Uuendamine…"
  },
  "fi": {
    "title": "Suodattimet",
    "back": "Takaisin",
    "close": "Sulje",
    "reset": "Tyhjennä",
    "searchBrand": "Etsi tuotemerkkiä",
    "searchIngredient": "Etsi ainesosaa",
    "empty": "Ei hakutuloksia",
    "show": "Näytä tuotteet",
    "loading": "Päivitetään…"
  },
  "pl": {
    "title": "Filtry",
    "back": "Wstecz",
    "close": "Zamknij",
    "reset": "Wyczyść",
    "searchBrand": "Szukaj marki",
    "searchIngredient": "Szukaj składnika",
    "empty": "Brak wyników",
    "show": "Pokaż produkty",
    "loading": "Aktualizowanie…"
  }
};

class YokoMobileFilters {
  constructor(host) {
    this.host = host;
    this.form = host.querySelector('#CollectionFiltersForm');
    if (!this.form || !this.wrapper) return;
    // Also recognize older minified markup whose bare data attribute was joined
    // to the following attribute. Reuse it instead of rendering a second toolbar.
    this.header = host.querySelector('[data-yoko-filter-ui], .yoko-filter-header');
    if (!this.header) this.createControls();
    this.header.dataset.yokoFilterUi = '';
    const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const defaults = yokoFilterTranslations[locale] || yokoFilterTranslations.en;
    for (const [key, value] of Object.entries(defaults)) {
      if (!this.header.dataset[key]) this.header.dataset[key] = value;
    }
    host.querySelectorAll('.yoko-filter-header').forEach(el => {
      if (el !== this.header) el.remove();
    });
    this.strings = this.header.dataset;
    this.media = window.matchMedia('(max-width: 1023px)');
    this.screens = new Set(['filter.p.vendor', 'filter.p.m.custom.active_ingredients_reference']);
    this.saved = new Map();
    this.mainScroll = 0;
    this.active = null;
    this.opened = false;
    this.host.classList.add('yoko-filter-panel');
    this.form.addEventListener('submit', e => {
      if (this.media.matches) e.preventDefault();
    });
    this.host.addEventListener('click', e => this.click(e));
    this.host.addEventListener('input', e => {
      if (e.target.matches('[data-filter-search]')) this.search(e.target.closest('details'));
    });
    this.host.addEventListener('keydown', e => this.keydown(e));
    this.media.addEventListener('change', () => {
      if (this.opened) this.close();
      this.active = null;
      this.saved.clear();
      this.enhance();
    });
    // The existing theme also closes overlays on an outside click.
    this.overlayObserver = new MutationObserver(() => {
      if (this.opened && !document.documentElement.classList.contains('activ-filter')) this.close();
    });
    this.overlayObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    this.syncCount();
    this.enhance();
  }
  createControls() {
    const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const strings = yokoFilterTranslations[locale] || yokoFilterTranslations.en;
    const header = document.createElement('div');
    header.className = 'yoko-filter-header';
    header.dataset.yokoFilterUi = '';
    Object.assign(header.dataset, strings);
    const button = (attribute, text, label) => {
      const el = document.createElement('button');
      el.type = 'button';
      el.setAttribute(attribute, '');
      el.textContent = text;
      if (label) el.setAttribute('aria-label', label);
      return el;
    };
    const back = button('data-filter-back', '‹', strings.back);
    back.hidden = true;
    const heading = document.createElement('strong');
    heading.dataset.filterHeading = '';
    heading.textContent = strings.title;
    header.append(back, button('data-filter-close', '×', strings.close), heading,
      button('data-filter-reset', strings.reset));
    this.form.prepend(header);
    this.header = header;
    if (!this.form.querySelector('.yoko-filter-footer')) {
      const footer = document.createElement('div');
      footer.className = 'yoko-filter-footer';
      const error = document.createElement('div');
      error.dataset.filterError = '';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      const show = button('data-filter-show', strings.show);
      show.className = 'yoko-filter-show';
      footer.append(error, show);
      this.form.append(footer);
    }
  }
  syncCount(source = document) {
    if (!this.wrapper) return;
    // The section owns the count even if its nested block still has older markup.
    const metadata = source.querySelector('[data-yoko-filter-count]');
    if (metadata) this.wrapper.dataset.resultCount = metadata.dataset.yokoFilterCount;
  }
  get wrapper() { return this.host.querySelector('.filters-item__wrapper'); }
  get blocks() { return Array.from(this.host.querySelectorAll('.filters-item')); }
  key(block) { return block.dataset.filterKey || block.querySelector('input[name]')?.name || block.dataset.index; }
  enhance() {
    if (!this.header) return;
    this.blocks.forEach(block => {
      const key = this.key(block);
      block.dataset.filterKey = key;
      const summary = block.querySelector('summary');
      if (!summary) return;
      if (!block.dataset.filterTitle) {
        const title = summary.firstElementChild.cloneNode(true);
        title.querySelectorAll('.count-bubble, .yoko-filter-selected').forEach(el => el.remove());
        block.dataset.filterTitle = title.textContent.trim();
      }
      const screen = this.screens.has(key);
      block.classList.toggle('yoko-filter-screen', screen);
      let chosen = summary.querySelector('.yoko-filter-selected');
      if (!chosen) {
        chosen = document.createElement('small');
        chosen.className = 'yoko-filter-selected';
        summary.firstElementChild.append(chosen);
      }
      chosen.textContent = Array.from(block.querySelectorAll('input[type="checkbox"]:checked')).map(input => {
        const label = input.closest('label').cloneNode(true);
        label.querySelectorAll('input, .checkbox, .prcnt, svg').forEach(el => el.remove());
        return label.textContent.trim();
      }).join(', ');
      if (screen && !block.querySelector('[data-filter-search]')) {
        const box = document.createElement('div');
        box.className = 'yoko-filter-search';
        const input = document.createElement('input');
        input.type = 'search';
        input.dataset.filterSearch = '';
        input.placeholder = key === 'filter.p.vendor' ? this.strings.searchBrand : this.strings.searchIngredient;
        input.setAttribute('aria-label', input.placeholder);
        input.autocomplete = 'off';
        // No name: this search narrows options locally and is never sent to Shopify.
        box.append(input);
        const empty = document.createElement('p');
        empty.dataset.filterEmpty = '';
        empty.textContent = this.strings.empty;
        empty.hidden = true;
        block.querySelector('.filters-select').prepend(box, empty);
      }
      if (this.media.matches) block.open = screen ? this.active === key : !!this.saved.get(key)?.open;
      else block.open = !this.host.classList.contains('filter-horizontal');
      const input = block.querySelector('[data-filter-search]');
      if (input) {
        input.value = this.media.matches ? this.saved.get(key)?.query || '' : '';
        this.search(block);
      }
    });
    this.navigation();
    this.updateCount();
  }
  search(block) {
    const input = block.querySelector('[data-filter-search]');
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    const query = normalize(input.value);
    let found = 0;
    block.querySelectorAll('.filters-select__list > li').forEach(li => {
      li.hidden = this.media.matches && !normalize(li.textContent).includes(query);
      if (!li.hidden) found++;
    });
    block.querySelector('[data-filter-empty]').hidden = found > 0;
  }
  capture() {
    if (!this.header) return null;
    const focus = document.activeElement;
    const state = { scroll: this.wrapper.scrollTop, focusId: this.host.contains(focus) ? focus.id : null,
      searchFocus: this.host.contains(focus) && focus.matches('[data-filter-search]') };
    this.blocks.forEach(block => this.saved.set(this.key(block), {
      pageScroll: this.saved.get(this.key(block))?.pageScroll || 0,
      open: block.open, query: block.querySelector('[data-filter-search]')?.value || '',
      scroll: block.querySelector('.filters-select')?.scrollTop || 0
    }));
    return state;
  }
  restore(state) {
    if (!state || !this.header) return;
    this.enhance();
    this.blocks.forEach(block => {
      const saved = this.saved.get(this.key(block));
      if (saved) {
        block.open = this.media.matches && this.screens.has(this.key(block)) ? this.active === this.key(block) : saved.open;
        block.querySelector('.filters-select').scrollTop = saved.scroll;
      }
    });
    this.navigation();
    this.wrapper.scrollTop = state.scroll;
    const focus = state.searchFocus ? this.host.querySelector('.yoko-filter-current [data-filter-search]') :
      state.focusId ? document.getElementById(state.focusId) : null;
    if (focus && this.host.contains(focus)) focus.focus({ preventScroll: true });
  }
  navigation() {
    const current = this.blocks.find(b => this.key(b) === this.active);
    if (!current || !this.media.matches) this.active = null;
    this.host.classList.toggle('yoko-filter-detail', !!this.active);
    this.blocks.forEach(b => b.classList.toggle('yoko-filter-current', this.key(b) === this.active));
    this.header.querySelector('[data-filter-back]').hidden = !this.active;
    this.header.querySelector('[data-filter-close]').hidden = !!this.active;
    this.header.querySelector('[data-filter-heading]').textContent = this.active ? current.dataset.filterTitle : this.strings.title;
    if (this.active) current.open = true;
  }
  click(e) {
    if (!this.header || !this.media?.matches) return;
    const target = e.target;
    if (target.closest('[data-filter-close], [data-filter-show]')) this.close();
    else if (target.closest('[data-filter-back]')) this.back();
    else if (target.closest('[data-filter-reset]')) {
      this.form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
      this.form.querySelectorAll('.price-range').forEach(input => { input.value = ''; });
      this.saved.clear();
      this.blocks.forEach(block => {
        const input = block.querySelector('[data-filter-search]');
        if (input) { input.value = ''; this.search(block); }
      });
      this.host.onFormSubmit();
    } else {
      const summary = target.closest('summary');
      const block = summary?.closest('.filters-item');
      if (block && this.screens.has(this.key(block))) {
        e.preventDefault();
        this.capture();
        this.mainScroll = this.wrapper.scrollTop;
        this.active = this.key(block);
        this.navigation();
        this.wrapper.scrollTop = this.saved.get(this.active)?.pageScroll || 0;
        this.header.querySelector('[data-filter-back]').focus({ preventScroll: true });
      }
    }
  }
  back() {
    const previous = this.active;
    if (!previous) return;
    this.capture();
    this.saved.get(previous).pageScroll = this.wrapper.scrollTop;
    this.active = null;
    const block = this.blocks.find(b => this.key(b) === previous);
    if (block) block.open = false;
    if (this.saved.has(previous)) this.saved.get(previous).open = false;
    this.navigation();
    this.wrapper.scrollTop = this.mainScroll;
    block?.querySelector('summary').focus({ preventScroll: true });
  }
  open(trigger) {
    // Tag-only forms without a dynamic filter wrapper keep their existing drawer.
    if (!this.header || !this.media?.matches) return false;
    if (this.opened) return true;
    this.returnFocus = trigger || document.activeElement;
    this.opened = true;
    this.host.setAttribute('role', 'dialog');
    this.host.setAttribute('aria-modal', 'true');
    this.host.setAttribute('aria-label', this.strings.title);
    document.documentElement.classList.add('activ-filter', 'show-overly');
    // Inert only siblings of the drawer's ancestors, never an ancestor of the drawer.
    this.inertElements = [];
    for (let node = this.host; node.parentElement && node !== document.body; node = node.parentElement) {
      Array.from(node.parentElement.children).forEach(sibling => {
        if (sibling !== node && !sibling.inert && !sibling.matches('script, style, link, .modal-overly')) {
          sibling.inert = true;
          this.inertElements.push(sibling);
        }
      });
    }
    this.enhance();
    this.header.querySelector(this.active ? '[data-filter-back]' : '[data-filter-close]').focus({ preventScroll: true });
    return true;
  }
  close() {
    if (!this.opened) return;
    this.capture();
    this.opened = false;
    document.documentElement.classList.remove('activ-filter', 'show-overly');
    this.host.removeAttribute('role');
    this.host.removeAttribute('aria-modal');
    this.host.removeAttribute('aria-label');
    this.inertElements?.forEach(el => { el.inert = false; });
    // AJAX refreshes the quick buttons while the drawer is open.
    const trigger = this.returnFocus?.isConnected ? this.returnFocus : document.getElementById(this.returnFocus?.id);
    trigger?.focus({ preventScroll: true });
  }
  keydown(e) {
    if (!this.opened) return;
    if (e.key === 'Escape') { e.preventDefault(); this.active ? this.back() : this.close(); }
    if (e.key !== 'Tab') return;
    const focusable = Array.from(this.host.querySelectorAll('button, summary, input, a[href], [tabindex="0"]'))
      .filter(el => !el.disabled && el.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
  }
  updateCount() {
    if (!this.header) return;
    const button = this.host.querySelector('[data-filter-show]');
    const count = this.wrapper.dataset.resultCount;
    button.textContent = this.busy ? this.strings.loading : `${this.strings.show}${count !== undefined ? ` (${count})` : ''}`;
    button.disabled = !!this.busy;
    button.setAttribute('aria-busy', String(!!this.busy));
  }
  setBusy(busy) {
    if (!this.header) return;
    this.busy = busy;
    if (busy) this.host.querySelector('[data-filter-error]').hidden = true;
    this.updateCount();
  }
  error(retry) {
    if (!this.header) return;
    const box = this.host.querySelector('[data-filter-error]');
    box.replaceChildren(document.createTextNode(window.yokoCollectionStrings.error + ' '));
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = window.yokoCollectionStrings.retry;
    button.addEventListener('click', retry, { once: true });
    box.append(button);
    box.hidden = false;
  }
}

// Independent brand/skin pickers; Shopify's original inputs own the filter state.
class YokoQuickFilter {
  constructor(host, { key = 'filter.p.vendor', kind = 'brand', prefix = 'YokoQuickBrands', searchable = true } = {}) {
    this.host = host;
    this.key = key;
    this.kind = kind;
    this.prefix = prefix;
    this.searchable = searchable;
    this.triggerSelector = '[data-yoko-quick-' + kind + ']';
    this.strings = host.mobileUI?.strings || yokoFilterTranslations.en;
    this.media = window.matchMedia('(max-width: 1023px)');
    this.mediaChange = () => { if (!this.media.matches) this.close(); };
    this.media.addEventListener('change', this.mediaChange);
    this.opened = false;
    this.busy = false;
  }
  get block() {
    return Array.from(this.host.querySelectorAll('.filters-item')).find(block =>
      (block.dataset.filterKey || block.querySelector('input[name]')?.name) === this.key);
  }
  get inputs() { return Array.from(this.block?.querySelectorAll('input.dyfl') || []); }
  create() {
    if (this.dialog) return;
    const button = (label, className) => {
      const element = document.createElement('button');
      element.type = 'button';
      element.className = className;
      element.textContent = label;
      return element;
    };
    this.dialog = document.createElement('dialog');
    this.dialog.id = this.prefix + '-' + this.host.secId;
    this.dialog.className = 'yoko-quick-brands' + (this.searchable ? '' : ' yoko-quick-brands--compact');
    const header = document.createElement('div');
    header.className = 'yoko-quick-brands__header';
    this.title = document.createElement('h2');
    this.title.id = this.dialog.id + '-title';
    this.title.textContent = this.block.dataset.filterTitle || '';
    this.dialog.setAttribute('aria-labelledby', this.title.id);
    const reset = button(this.strings.reset, 'yoko-quick-brands__reset');
    reset.addEventListener('click', () => {
      this.inputs.forEach(input => { input.checked = false; });
      this.host.onFormSubmit();
    });
    const close = button('×', 'yoko-quick-brands__close');
    close.setAttribute('aria-label', this.strings.close);
    close.addEventListener('click', () => this.close());
    header.append(this.title, reset, close);
    const searchBox = document.createElement('div');
    searchBox.className = 'yoko-quick-brands__search';
    this.search = document.createElement('input');
    this.search.type = 'search';
    this.search.placeholder = this.strings.searchBrand;
    this.search.setAttribute('aria-label', this.strings.searchBrand);
    this.search.autocomplete = 'off';
    this.search.addEventListener('input', () => { this.filter(); this.list.scrollTop = 0; });
    searchBox.append(this.search);
    this.list = document.createElement('div');
    this.list.className = 'yoko-quick-brands__list';
    this.list.addEventListener('change', event => {
      if (!event.target.matches('[data-quick-filter-value]')) return;
      const input = this.inputs.find(input => input.value === event.target.value);
      if (!input || input.disabled) return;
      input.checked = event.target.checked;
      this.host.onFormSubmit();
    });
    this.empty = document.createElement('p');
    this.empty.className = 'yoko-quick-brands__empty';
    this.empty.textContent = this.strings.empty;
    this.empty.hidden = true;
    this.empty.setAttribute('role', 'status');
    const footer = document.createElement('div');
    footer.className = 'yoko-quick-brands__footer';
    this.errorBox = document.createElement('div');
    this.errorBox.className = 'yoko-quick-brands__error';
    this.errorBox.setAttribute('role', 'alert');
    this.errorBox.hidden = true;
    this.show = button(this.strings.show, 'yoko-quick-brands__show');
    this.show.addEventListener('click', () => this.close());
    footer.append(this.errorBox, this.show);
    this.dialog.append(header);
    if (this.searchable) this.dialog.append(searchBox);
    this.dialog.append(this.list, footer);
    this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
    this.dialog.addEventListener('close', () => this.finishClose());
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
    });
    document.body.append(this.dialog);
  }
  filter() {
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    const query = normalize(this.search.value);
    let visible = 0;
    this.list.querySelectorAll('li').forEach(item => {
      item.hidden = !normalize(item.dataset.filterLabel).includes(query);
      if (!item.hidden) visible++;
    });
    this.empty.hidden = visible > 0;
  }
  sync() {
    if (!this.dialog || !this.block) return;
    const scroll = this.list.scrollTop;
    const focused = document.activeElement;
    const focusValue = this.list.contains(focused) && focused.matches('[data-quick-filter-value]') ? focused.value : null;
    const items = document.createElement('ul');
    this.inputs.forEach((input, index) => {
      const source = input.closest('label');
      const copy = source.cloneNode(true);
      copy.querySelectorAll('input, .checkbox, .prcnt, svg').forEach(element => element.remove());
      const name = copy.textContent.trim();
      const item = document.createElement('li');
      item.dataset.filterLabel = name;
      const label = document.createElement('label');
      const check = document.createElement('input');
      check.type = 'checkbox';
      check.id = this.dialog.id + '-value-' + index;
      check.value = input.value;
      check.dataset.quickFilterValue = '';
      check.setAttribute('data-quick-' + this.kind + '-value', '');
      check.checked = input.checked;
      check.disabled = input.disabled;
      label.htmlFor = check.id;
      const text = document.createElement('span');
      text.className = 'yoko-quick-brands__name';
      text.textContent = name;
      const count = document.createElement('span');
      count.className = 'yoko-quick-brands__count';
      count.textContent = source.querySelector('.prcnt')?.textContent.trim() || '';
      label.append(check, text, count);
      item.append(label);
      items.append(item);
    });
    this.list.replaceChildren(items, this.empty);
    this.filter();
    this.list.scrollTop = scroll;
    this.updateButton();
    if (focusValue !== null && this.opened) {
      Array.from(this.list.querySelectorAll('[data-quick-filter-value]')).find(input => input.value === focusValue)?.focus({ preventScroll: true });
    }
    this.syncTrigger();
  }
  updateButton() {
    if (!this.show) return;
    const count = this.host.querySelector('.filters-item__wrapper')?.dataset.resultCount;
    this.show.textContent = this.busy ? this.strings.loading : this.strings.show + (count !== undefined ? ' (' + count + ')' : '');
    this.show.disabled = this.busy;
    this.show.setAttribute('aria-busy', String(this.busy));
  }
  syncTrigger() {
    document.querySelector(this.triggerSelector)?.setAttribute('aria-expanded', String(this.opened));
  }
  setBusy(busy) {
    this.busy = busy;
    if (busy && this.errorBox) this.errorBox.hidden = true;
    this.updateButton();
  }
  error(retry) {
    if (!this.opened || !this.errorBox) return;
    this.errorBox.replaceChildren(document.createTextNode(window.yokoCollectionStrings.error + ' '));
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = window.yokoCollectionStrings.retry;
    button.addEventListener('click', retry, { once: true });
    this.errorBox.append(button);
    this.errorBox.hidden = false;
  }
  open(trigger) {
    if (!this.media.matches || this.host.mobileUI?.opened || !this.block) return false;
    this.host.quickPickers?.forEach(picker => { if (picker !== this) picker.close(); });
    this.create();
    if (this.opened) return true;
    this.returnFocusId = trigger.id;
    this.search.value = '';
    this.list.scrollTop = 0;
    this.sync();
    this.dialog.showModal();
    this.opened = true;
    document.documentElement.classList.add('yoko-quick-brands-open');
    this.syncTrigger();
    // Keep the list visible without raising the mobile keyboard automatically.
    this.dialog.querySelector('.yoko-quick-brands__close').focus({ preventScroll: true });
    return true;
  }
  close() {
    if (!this.opened) return;
    this.dialog.close();
    this.finishClose();
  }
  finishClose() {
    if (!this.opened) return;
    this.opened = false;
    if (!this.host.quickPickers?.some(picker => picker.opened)) document.documentElement.classList.remove('yoko-quick-brands-open');
    this.syncTrigger();
    document.getElementById(this.returnFocusId)?.focus({ preventScroll: true });
  }
  destroy() {
    this.close();
    this.dialog?.remove();
    this.media.removeEventListener?.('change', this.mediaChange);
  }
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.lastFilterHTML = this.querySelector('.filters-item__wrapper')?.innerHTML;
      this.lastSort = document.getElementById('sort-by')?.value;
      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 1024px)');
  
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();
      this.mobileUI = new YokoMobileFilters(this);
      this.quickBrands = new YokoQuickFilter(this);
      this.quickSkin = new YokoQuickFilter(this, { key: 'filter.p.m.custom.skin_types_reference', kind: 'skin', prefix: 'YokoQuickSkinDialog', searchable: false });
      this.quickPickers = [this.quickBrands, this.quickSkin];
      this.syncMainFilterCount();
      const quickFilters = document.getElementById('YokoCollectionQuickFilters');
      quickFilters?.addEventListener('click', event => {
        const picker = this.quickPickers.find(picker => event.target.closest(picker.triggerSelector));
        if (picker) picker.open(event.target.closest(picker.triggerSelector));
      });
      quickFilters?.addEventListener('change', event => {
        const shortcut = event.target.closest('[data-yoko-quick-availability], [data-yoko-quick-sale]');
        if (!shortcut) return;
        // Boolean shortcuts replace their own group, leaving other facets intact.
        const inputs = Array.from(this.querySelectorAll('input.dyfl')).filter(input => input.name === shortcut.dataset.param);
        if (!inputs.some(input => input.value === shortcut.value)) return;
        inputs.forEach(input => { input.checked = shortcut.checked && input.value === shortcut.value; });
        this.onFormSubmit();
      });

      document.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;
        _this.syncMainFilterCount();

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    if (shortby) shortby.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  syncMainFilterCount() {
    // Count canonical form selections only, never the independent dialog copies.
    let count = this.querySelectorAll('input.dyfl[type="checkbox"]:checked, input.optTag[type="checkbox"]:checked').length;
    if (Array.from(this.querySelectorAll('.price-range')).some(input => input.value.trim() !== '')) count++;
    document.querySelectorAll('[data-yoko-filter-trigger], .yoko-collection-toolbar .btn-filter').forEach(button => {
      let badge = button.querySelector('[data-yoko-filter-count-badge]');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'yoko-filter-count';
        badge.dataset.yokoFilterCountBadge = '';
        button.prepend(badge);
      }
      badge.textContent = String(count);
      badge.hidden = count === 0;
      button.dataset.active = String(count > 0);
      // Visible text includes the count; an old label would hide it from screen readers.
      button.removeAttribute('aria-label');
    });
  }
  syncQuickFilters() {
    this.syncMainFilterCount();
    document.querySelectorAll('[data-yoko-quick-availability], [data-yoko-quick-sale]').forEach(shortcut => {
      const input = Array.from(this.querySelectorAll('input.dyfl')).find(input => input.name === shortcut.dataset.param && input.value === shortcut.value);
      if (!input) return;
      shortcut.checked = input.checked;
      shortcut.disabled = input.disabled;
    });
    const brand = document.querySelector('[data-yoko-quick-brand]');
    if (brand) {
      const selected = Array.from(this.querySelectorAll('input.dyfl')).filter(input => input.name === 'filter.p.vendor' && input.checked);
      brand.dataset.active = String(selected.length > 0);
      brand.querySelector('[data-yoko-quick-brand-values]').textContent = selected.length === 1 ? ': ' + selected[0].value : '';
    }
    const skin = document.querySelector('[data-yoko-quick-skin]');
    if (skin) skin.dataset.active = String(this.quickSkin.inputs.some(input => input.checked));
    this.quickPickers?.forEach(picker => picker.sync());
  }
  priceRangeSlider(){
    const priceSlider = this.querySelector('#priceSlider'),
      min = this.querySelector('[name="filter.v.price.gte"]'),
      max = this.querySelector('[name="filter.v.price.lte"]');
    if (!priceSlider || !min || !max) return;

    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    let lastRange = min.value + '|' + max.value;
    const submitRange = () => {
        const range = min.value + '|' + max.value;
        if (range === lastRange) return;
        lastRange = range;
        this.onFormSubmit();
    };
    priceSlider.addEventListener('onMouseUp', submitRange);
    priceSlider.addEventListener('touchend', submitRange);
  }
  onFormSubmit(e){
    this.syncQuickFilters();
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData);
      if (document.body.classList.contains('template-search')) {
        const type = new URLSearchParams(window.location.search).get('type');
        if (type && type.split(',').every(value => ['product', 'article', 'page'].includes(value))) params.set('type', type);
        else params.delete('type');
      }
      this.renderSectionFromFetch(params);
  }
  renderSectionFromFetch(params,tags){
    const target = tags
      ? new URL(params, window.location.origin)
      : new URL(window.location.pathname + '?' + params.toString(), window.location.origin);
    target.searchParams.delete('page');
    target.searchParams.delete('section_id');
    const pageUrl = target.pathname + target.search;
    const request = new URL(target);
    request.searchParams.set('section_id', this.secId);
    const retry = () => this.renderSectionFromFetch(pageUrl, true);
    const mobileRequest = (this.mobileRequest || 0) + 1;
    this.mobileRequest = mobileRequest;
    this.mobileUI?.setBusy(true);
    this.quickPickers?.forEach(picker => picker.setBusy(true));
    return yokoListingFetch(request.pathname + request.search, html => {
        if (!html.querySelector('#collection-products') && html.querySelector('.noresult')) {
            window.location.assign(pageUrl);
            return;
        }
        // Validate all required fragments before updating any visible state.
        const pairs = [
            [document.getElementById('collection-products'), html.querySelector('#collection-products')],
            [this.querySelector('.filters-item__wrapper'), html.querySelector('.filters-item__wrapper')],
            [document.getElementById('itemsCount'), html.querySelector('#itemsCount')],
            [document.getElementById('YokoCollectionQuickFilters'), html.querySelector('#YokoCollectionQuickFilters')],
            [document.getElementById('active-filters'), html.querySelector('#active-filters')]
        ];
        if (pairs.some(([destination, source]) => destination && !source)) throw new Error('Incomplete listing');
        const filterState = this.mobileUI?.capture();
        const shortcutFocus = document.activeElement?.matches('[data-yoko-quick-availability], [data-yoko-quick-brand], [data-yoko-quick-skin], [data-yoko-quick-sale]') ? document.activeElement.id : null;
        pairs.forEach(([destination, source]) => {
          if (!destination) return;
          destination.innerHTML = source.innerHTML;
          if (source.dataset.resultCount !== undefined) destination.dataset.resultCount = source.dataset.resultCount;
        });
        const searchHeading = document.querySelector('[data-yoko-search-heading]');
        const nextSearchHeading = html.querySelector('[data-yoko-search-heading]');
        if (searchHeading && nextSearchHeading) {
            searchHeading.innerHTML = nextSearchHeading.innerHTML;
            const breadcrumb = document.querySelector('.yoko-breadcrumb .fw-500');
            if (breadcrumb) breadcrumb.textContent = nextSearchHeading.dataset.pageTitle;
            document.title = nextSearchHeading.dataset.documentTitle;
        }
        const pager = document.getElementById('pagination');
        const pagerSource = html.querySelector('#pagination');
        if (pager) pager.innerHTML = pagerSource ? pagerSource.innerHTML : '';
        const sort = document.getElementById('sort-by');
        const sortSource = html.querySelector('#sort-by');
        if (sort && sortSource) sort.value = sortSource.value;
        updateYokoCollectionLanding(html);
        this.lastFilterHTML = this.querySelector('.filters-item__wrapper')?.innerHTML;
        this.lastSort = sort?.value;
        if (pageUrl !== window.location.pathname + window.location.search) history.pushState({ page: pageUrl }, '', pageUrl);
        this.selectFilters();this.priceRangeSlider();this.removeFilters();
        this.syncQuickFilters();
        this.mobileUI?.syncCount(html);
        this.mobileUI?.restore(filterState);
        if (shortcutFocus) document.getElementById(shortcutFocus)?.focus({ preventScroll: true });
    }, retry, () => {
        const filterState = this.mobileUI?.capture();
        const filters = this.querySelector('.filters-item__wrapper');
        if (filters && this.lastFilterHTML !== undefined) filters.innerHTML = this.lastFilterHTML;
        const sort = document.getElementById('sort-by');
        if (sort && this.lastSort !== undefined) sort.value = this.lastSort;
        this.selectFilters();this.priceRangeSlider();
        this.syncQuickFilters();
        this.mobileUI?.restore(filterState);
        this.mobileUI?.error(retry);
        this.quickPickers?.forEach(picker => picker.error(retry));
    }).finally(() => {
        if (this.mobileRequest === mobileRequest) {
            this.mobileUI?.setBusy(false);
            this.quickPickers?.forEach(picker => picker.setBusy(false));
        }
    });
  }

  disconnectedCallback() {
    this.quickPickers?.forEach(picker => picker.destroy());
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl");
    activeFl.forEach((btn) => {
        btn.setAttribute('href', yokoSearchLink(btn.getAttribute('href')));
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          _this.renderSectionFromFetch(btn.getAttribute('href'), true);
        })
      });
  }
  mobileFilters(event){
    if (this.mobileUI?.open(event?.currentTarget)) return;
    var html = document.documentElement;
    html.classList.add('activ-filter','show-overly');
    const blocks = this.querySelectorAll('.filters-item');
    blocks.forEach((blk) => {
      blk.open = true;
    });
    document.querySelector(".closeFilter").addEventListener('click', function(e){
        html.classList.remove('activ-filter','show-overly');
    });
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});

